{
  "upload": {
    "title": "您的商标",
    "subtitle": "上传您的商标图片或输入文字商标",
    "selectType": "哪个选项最能描述您的商标？",
    "logoTrademark": "标志商标",
    "logoDescription": "包含文字的品牌标志",
    "figurativeTrademark": "图形商标",
    "figurativeDescription": "不包含文字的品牌图形元素",
    "wordTrademark": "文字商标",
    "wordDescription": "品牌名称或标语",
    "uploadYour": "上传您的{{type}}商标",
    "dragDrop": "将图片拖放到此处，或",
    "browseFiles": "浏览文件",
    "supportedFormats": "支持格式：PNG、JPG、GIF",
    "enterWordMark": "输入您的文字商标",
    "wordPlaceholder": "输入您的商标文字",
    "uploadWordMark": "上传文字商标",
    "removeImage": "移除图片",
    "uploading": "正在上传商标...",
    "uploadSuccess": "商标上传成功！",
    "imageSuccess": "图片商标上传成功",
    "uploadDifferent": "上传其他商标",
    "selectImage": "选择图片自动上传",
    "uploadError": "商标上传失败，请重试。"
  },
  "analysis": {
    "title": "AI驱动分析",
    "subtitle": "我们的AI将分析您的商标的独特性、潜在冲突和注册策略",
    "readyTitle": "准备进行AI驱动的商标分析",
    "readySubtitle": "我们的AI将分析您的商标的独特性、潜在冲突和注册策略",
    "yourTrademark": "您的商标",
    "trademarkRequired": "需要商标",
    "businessProfile": "企业资料",
    "businessRequired": "需要企业资料",
    "trademarkName": "商标名称",
    "trademarkNameDesc": "这是将在您的商标注册下受保护的名称或文字",
    "trademarkType": "商标类型",
    "logoTypeDesc": "代表您品牌的视觉设计或标志",
    "wordTypeDesc": "标识您商品或服务的词语或短语",
    "detailedDescription": "详细描述",
    "trademarkDescription": "商标描述",
    "viewDescription": "查看详细商标描述",
    "descriptionHelp": "此描述帮助我们的AI理解您商标的视觉和概念元素",
    "descRequired": "需要描述",
    "descRequiredMsg": "请添加商标的详细描述以继续分析",
    "descRequiredHelp": "好的描述包括颜色、设计元素、字体和整体外观",
    "noTrademark": "未选择商标",
    "noTrademarkMsg": "请先完成商标上传步骤",
    "noTrademarkHelp": "您需要先上传商标才能进行分析",
    "readyToAnalyse": "准备分析",
    "analyseButton": "分析我的商标",
    "analysing": "正在分析您的商标...",
    "analysisComplete": "分析完成",
    "viewReport": "查看完整报告",
    "overallScore": "综合评分",
    "distinctiveness": "独特性",
    "conflictRisk": "冲突风险",
    "registrability": "可注册性",
    "recommendations": "建议",
    "potentialConflicts": "潜在冲突",
    "noConflicts": "未发现重大冲突",
    "needsUpload": "您需要先上传商标才能进行分析",
    "classRecommendations": "类别建议",
    "suggestedClasses": "建议的尼斯分类"
  },
  "business": {
    "title": "企业信息",
    "complete": "企业信息已完成",
    "completeDescription": "您的企业信息已成功保存，将用于提供准确的商标建议。",
    "subtitle": "告诉我们您的业务情况，以便Marko提供个性化建议",
    "ownerType": "商标所有人类型",
    "individual": "个人",
    "company": "公司",
    "partnership": "合伙企业",
    "businessName": "企业名称",
    "tradingAs": "商号",
    "registrationNumber": "注册号",
    "industry": "行业",
    "selectIndustry": "选择您的行业",
    "goodsServices": "商品和服务",
    "describeGoodsServices": "描述您的商标将涵盖的商品或服务",
    "markoAnalyse": "Marko会在您输入时分析您的信息。",
    "analysed": "我已分析您的商标"
  },
  "classes": {
    "title": "尼斯分类",
    "subtitle": "选择最能描述您的商品和服务的类别",
    "selectedClasses": "已选类别",
    "noClassesSelected": "未选择类别",
    "addClass": "添加类别",
    "removeClass": "移除类别",
    "searchClasses": "搜索类别...",
    "classNumber": "第{{number}}类",
    "viewDetails": "查看类别详情"
  }
}
